export const RESPONSIBLE_ROLES = ['managements', 'technicians', 'analysts', 'marketing', 'store_managers']

export const RESPONSIBLE_LABELS = {
	managements: 'management_support',
	technicians: 'technical_support',
	analysts: 'analytical_manager',
	marketing: 'marketing_support',
	store_managers: 'store_manager_alias',
}
